export function formatedDateString(date, options) {
  return new Date(date).toLocaleDateString(
    undefined,
    options || {
      month: 'short',
      day: 'numeric',
    }
  );
}

export function avatarFromName(name) {
  try {
    return name
      .trim()
      .split(/[ ]+/)
      .slice(0, 2)
      .map((seg, index) =>
        index > 0 ? seg[0].toLowerCase() : seg[0].toUpperCase()
      )
      .join('');
  } catch {
    return '-_';
  }
}
